module.exports = __webpack_public_path__ + "img/GAME_SOUNDLINK1.b33b5353.jpg";